import React from "react";

export default function productCategoryIcon({ name }) {
  switch (name) {
    case "Cognition":
      return (
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.7333 7.77868L11.3248 8.01495L11.2653 8.6059C11.2949 8.6355 11.3208 8.66509 11.3448 8.69468L11.4816 8.87206L11.5611 8.96057L12.152 8.90162L12.3883 9.49256L11.9157 9.84723C11.9157 9.96562 11.9157 10.143 11.8563 10.3203L12.3293 10.675L12.0931 11.2659L11.5021 11.2065C11.4725 11.236 11.4429 11.2619 11.4133 11.286L11.236 11.4227L11.1475 11.5022L11.2064 12.0931L10.6155 12.3294L10.2608 11.8568H9.78773L9.43307 12.3294L8.84212 12.0931L8.90107 11.5022C8.78318 11.3838 8.72424 11.2659 8.60585 11.1475L8.0149 11.2065L7.77813 10.6155L8.25118 10.2608V9.78829L7.77813 9.43362L8.0149 8.84268L8.60585 8.90162C8.72424 8.78323 8.84212 8.72429 8.96051 8.6059L8.90107 8.01495L9.49252 7.77868L9.84718 8.25174H10.3197L10.7333 7.77868ZM9.31518 9.78829C9.13785 10.2019 9.37412 10.675 9.78773 10.8523C10.2018 11.0291 10.6744 10.7928 10.8517 10.3792C11.0291 9.96562 10.7928 9.49257 10.3787 9.31523C9.96507 9.1379 9.49251 9.37468 9.31518 9.78829ZM5.82816 1.75L6.06444 2.63667C6.30072 2.69561 6.53699 2.75506 6.71433 2.87294L7.54205 2.45933L8.25138 3.16867L7.77833 3.93694C7.89672 4.17322 8.0146 4.35055 8.07405 4.58733L8.96021 4.82361V5.82816L8.07405 6.06494C7.95566 6.30122 7.89672 6.5375 7.77833 6.71483L8.19194 7.54205L7.4826 8.25138L6.71433 7.83777C6.47805 7.95616 6.30072 8.07405 6.06444 8.1335L5.82816 9.01966H4.82311L4.58683 8.1335C4.35055 8.01511 4.11377 7.95616 3.93644 7.83777L3.16816 8.25138L2.51828 7.48311L2.93189 6.71483C2.8135 6.47855 2.69561 6.30122 2.63616 6.06494L1.75 5.82816V4.82361L2.63616 4.58733C2.69561 4.35055 2.75455 4.17322 2.87294 3.93694L2.45883 3.16867L3.16816 2.45933L3.93644 2.87294C4.17322 2.75506 4.35055 2.69561 4.58683 2.63667L4.82311 1.75H5.82816ZM5.35511 3.99589C4.58683 3.99589 3.99589 4.58733 3.99589 5.35561C3.99589 6.12389 4.58683 6.71483 5.35511 6.71483C6.12338 6.71483 6.71433 6.12389 6.71433 5.35561C6.71433 4.58733 6.12338 3.99589 5.35511 3.99589Z"
            fill="#232D37"
          />
        </svg>
      );
    case "Endurance":
      return (
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.23 6.09V4.55H11.69V9.17H13.23V7.63H14V6.09H13.23ZM0.77 6.09H0V7.63H0.77V9.17H2.31V4.55H0.77V6.09ZM9.45 6.09H4.55V3.5H3.01V10.22H4.55V7.63H9.45V10.22H10.99V3.5H9.45V6.09Z"
            fill="#232D37"
          />
        </svg>
      );
    case "Fitness":
      return (
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.23 6.09V4.55H11.69V9.17H13.23V7.63H14V6.09H13.23ZM0.77 6.09H0V7.63H0.77V9.17H2.31V4.55H0.77V6.09ZM9.45 6.09H4.55V3.5H3.01V10.22H4.55V7.63H9.45V10.22H10.99V3.5H9.45V6.09Z"
            fill="#232D37"
          />
        </svg>
      );
    case "Gut Health":
      return (
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.80626 0.675718C7.69862 0.606217 7.57572 0.590113 7.45198 0.583332C7.32569 0.590113 7.20364 0.607064 7.09515 0.675718C6.9697 0.75539 6.96631 0.867271 7.09515 0.939315C7.32908 1.06815 7.57064 1.06815 7.80457 0.939315C7.9351 0.867271 7.93086 0.75539 7.80626 0.675718ZM3.19767 10.0324L3.19918 10.0297L3.19698 10.0308L3.19767 10.0324ZM2.73927 10.8569L2.73957 10.8564C2.89158 10.5832 3.04378 10.3096 3.19767 10.0324C3.21048 10.0623 3.21805 10.0807 3.22455 10.0981C3.55648 11.0156 4.02075 11.8537 4.69675 12.5639C4.99891 12.8804 5.33085 13.1605 5.73667 13.338C6.44245 13.6479 7.17249 13.6644 7.91245 13.5012C8.77703 13.3104 9.52912 12.8925 10.2073 12.3345C10.9771 11.7026 11.5891 10.9351 12.1052 10.0881C12.6246 9.23458 12.9334 8.31156 12.9885 7.31134C13.0326 6.51624 12.9146 5.74319 12.6401 4.99551C12.3688 4.25665 11.9861 3.58616 11.4138 3.03587C11.2175 2.8473 11.0035 2.68188 10.7378 2.60028C10.2922 2.46574 9.85113 2.48779 9.41554 2.64328C9.12551 2.74584 8.86415 2.90023 8.62485 3.10314C8.38554 2.8076 8.19697 2.49551 8.19035 2.10623C8.18744 1.90519 8.18837 1.70415 8.18934 1.49548C8.18984 1.38824 8.19035 1.27898 8.19035 1.16667C7.71726 1.50963 7.25078 1.52617 6.78541 1.17659C6.76997 1.50853 6.80857 1.84157 6.88577 2.1713C7.00597 2.68409 7.26733 3.1252 7.58493 3.53543C7.63124 3.59498 7.63235 3.63799 7.59926 3.70195C7.49943 3.89433 7.40548 4.09064 7.31187 4.28625L7.31186 4.28626L7.31185 4.28629L7.2949 4.32171L7.26349 4.3874C7.11368 4.70038 6.96444 5.01215 6.90672 5.36053C6.79644 6.02771 6.68175 6.69379 6.56375 7.35986C6.50531 7.68849 6.43032 8.01271 6.31232 8.327C6.14249 8.78024 5.56023 9.13313 5.01215 8.86846C4.74748 8.74164 4.48171 8.61482 4.20933 8.50785C3.66896 8.29502 3.15507 8.35457 2.69742 8.71959C2.532 8.85082 2.37541 9.003 2.24859 9.17173C2.00551 9.49472 1.77375 9.82588 1.54191 10.1571C1.46662 10.2647 1.39133 10.3723 1.31564 10.4796C1.26861 10.5461 1.22456 10.615 1.17955 10.6854L1.17954 10.6854C1.16333 10.7107 1.14701 10.7362 1.13037 10.7619C1.16721 10.7619 1.20329 10.7609 1.23877 10.76L1.23886 10.76H1.23887H1.23888C1.31594 10.7579 1.39019 10.7558 1.46341 10.7641C1.90232 10.8116 2.26182 11.1082 2.3732 11.5151C2.49562 11.2948 2.61739 11.0759 2.73927 10.8569ZM4.51345 11.2342C4.51173 11.2289 4.51002 11.2236 4.50818 11.2185L4.50928 11.2196H5.3928C5.75408 11.2189 6.03133 11.2191 6.33845 11.2193H6.33876H6.33911L6.87947 11.2196H8.98486C9.13748 11.2196 9.24659 11.2207 9.34871 11.2217H9.34881H9.34894C9.5349 11.2236 9.69776 11.2253 10.0581 11.2196C10.0816 11.2192 10.1924 11.2194 10.2742 11.2195L10.3496 11.2196C10.3405 11.2391 10.3456 11.2436 10.3488 11.2466C10.3507 11.2483 10.352 11.2494 10.3496 11.2527C9.74747 11.9849 9.02405 12.5484 8.10544 12.8219C7.19895 13.091 6.33658 12.9631 5.53928 12.458C5.08052 12.168 4.74197 11.7655 4.52472 11.2648C4.52031 11.2552 4.51688 11.2447 4.51345 11.2342ZM10.1276 9.04886H9.34945C9.22148 9.04886 9.10422 8.94223 9.10422 8.8037V7.78033L8.09157 7.78026C7.95304 7.78026 7.84641 7.6737 7.84641 7.5351V6.75697C7.84641 6.61844 7.95297 6.51181 8.09157 6.51181H9.11494L9.11501 5.49916C9.11501 5.36063 9.22157 5.254 9.36016 5.254H10.1383C10.2768 5.254 10.3835 5.36056 10.3835 5.49916V6.52253L11.3961 6.5226C11.5346 6.5226 11.6413 6.62916 11.6413 6.76776V7.5459C11.6413 7.68442 11.5347 7.79105 11.3961 7.79105H10.3727V8.8037C10.3727 8.94223 10.2662 9.04886 10.1276 9.04886ZM1.40926 11.0833L1.41013 11.0834L1.39656 11.0845C1.38457 11.0855 1.3751 11.0863 1.36519 11.0876C1.2906 11.0944 1.21601 11.1071 1.18041 11.1833C1.14312 11.263 1.1872 11.3308 1.23466 11.3893C1.39485 11.5859 1.6059 11.6843 1.85678 11.6953C1.94069 11.6995 2.03308 11.6894 2.07546 11.6012C2.11784 11.5122 2.06444 11.4368 2.0085 11.3732C1.84935 11.1904 1.64286 11.1022 1.41013 11.0834L1.41096 11.0833H1.40926Z"
            fill="#232D37"
          />
        </svg>
      );
    case "Heart Health":
      return (
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.99476 3.23992C0.89042 4.44869 0.89042 6.33666 1.99476 7.54544L6.99976 12.8333C8.69303 11.0956 10.3857 9.3586 12.0054 7.54544C13.1091 6.33732 13.1091 4.44869 12.0054 3.23992C10.9011 2.03114 9.06072 2.03114 7.88348 3.23992L6.92622 4.22164L5.9696 3.23992C4.9388 2.10661 3.09909 2.10661 1.99476 3.23992Z"
            fill="#232D37"
          />
        </svg>
      );
    case "Inflammation":
      return (
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.7108 7.6415C10.1877 6.533 9.37412 5.658 8.67662 4.725C7.97912 3.85 7.74646 3.0915 7.74646 1.75C4.60772 4.2 6.00271 6.65 6.00271 6.65C5.07255 6.4165 4.89818 5.658 4.89818 5.658C2.80568 8.5165 3.09664 11.1415 5.53788 12.25C3.96851 9.2165 7.63037 7.525 7.63037 7.525L6.93288 9.2165C6.7585 9.625 6.93288 10.0915 7.33942 10.2665C7.74646 10.4415 8.21129 10.2665 8.38566 9.858L8.73441 8.983C8.73441 8.983 9.89724 10.0915 9.02537 12.25C10.8852 11.375 11.5827 9.508 10.7108 7.6415Z"
            fill="#232D37"
          />
        </svg>
      );

    case "Metabolism":
      return (
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.5694 1.28917L2.52607 6.7025C2.15274 7.04083 2.36274 7.665 2.8644 7.71167L7.58357 8.16667L4.7544 12.11C4.62607 12.2908 4.64357 12.5417 4.80107 12.6992C4.97607 12.8742 5.25024 12.88 5.43107 12.7108L11.4744 7.2975C11.8477 6.95917 11.6377 6.335 11.1361 6.28833L6.4169 5.83334L9.24607 1.89C9.3744 1.70917 9.3569 1.45833 9.1994 1.30083C9.0244 1.12583 8.75024 1.12 8.5694 1.28917Z"
            fill="#232D37"
          />
        </svg>
      );
    case "Sleep":
      return (
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.25 8.81183C11.6299 9.05742 10.955 9.19392 10.2474 9.19392C7.24208 9.19392 4.80608 6.75792 4.80608 3.75258C4.80608 3.04558 4.94258 2.37008 5.18817 1.75C3.17508 2.548 1.75 4.5115 1.75 6.80867C1.75 9.814 4.186 12.25 7.19133 12.25C9.4885 12.25 11.452 10.8255 12.25 8.81183Z"
            fill="#232D37"
          />
        </svg>
      );
    case "Recovery":
      return (
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.57551 7.79356C3.50818 7.68585 3.38705 7.6051 3.26591 7.6051H2.55244L2.55235 7.22817C2.55235 4.76467 4.55817 2.75888 7.02164 2.75888C8.07166 2.75888 9.0947 3.1358 9.90245 3.80889C10.0909 3.95697 10.3601 3.94355 10.5082 3.75508C10.6563 3.56662 10.6429 3.29741 10.4544 3.14933C9.49857 2.34158 8.27362 1.8839 7.0082 1.8839C4.07354 1.8839 1.67735 4.28009 1.67735 7.21475V7.59168H0.977318C0.842662 7.59168 0.721521 7.65901 0.667722 7.78014C0.613916 7.90127 0.613916 8.03593 0.68115 8.15707L1.82545 9.92053C1.89277 10.0282 2.00048 10.082 2.1216 10.082C2.24274 10.082 2.35044 10.0147 2.41776 9.92053L3.56206 8.14353C3.62929 8.03592 3.62932 7.90128 3.57551 7.79356ZM13.3622 6.29929L12.2179 4.53583C12.0832 4.33394 11.7467 4.33394 11.6256 4.53583L10.4813 6.31283C10.4139 6.42053 10.4005 6.55509 10.4678 6.67632C10.5352 6.78402 10.6563 6.86478 10.7774 6.86478H11.4909L11.491 7.22817C11.491 9.69167 9.48518 11.6975 7.02171 11.6975C5.97169 11.6975 4.94865 11.3205 4.14089 10.6475C3.95244 10.4994 3.68322 10.5128 3.53514 10.7013C3.38706 10.8897 3.40048 11.1589 3.58895 11.307C4.54478 12.1148 5.76972 12.5724 7.03515 12.5724C9.96981 12.5724 12.366 10.1763 12.366 7.24159V6.86466H13.0795C13.2141 6.86466 13.3353 6.79734 13.3891 6.6762C13.4294 6.55507 13.4294 6.42041 13.3622 6.29928L13.3622 6.29929ZM7.50632 9.62435H6.52363C6.36203 9.62435 6.21395 9.48969 6.21395 9.31475V8.02238L4.9351 8.02228C4.76016 8.02228 4.62551 7.88772 4.62551 7.71269V6.73001C4.62551 6.55507 4.76007 6.42041 4.9351 6.42041H6.22748L6.22757 5.14157C6.22757 4.96663 6.36214 4.83197 6.53717 4.83197H7.51985C7.69479 4.83197 7.82945 4.96654 7.82945 5.14157V6.43394L9.10829 6.43404C9.28323 6.43404 9.41788 6.5686 9.41788 6.74363V7.72631C9.41788 7.90125 9.28332 8.03591 9.10829 8.03591H7.81591V9.31475C7.81591 9.48969 7.68135 9.62435 7.50632 9.62435Z"
            fill="#232D37"
          />
        </svg>
      );
    case "Hormone Balance":
      return (
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.82842 6.81392L11.0832 4.66317L12.3373 6.81392H9.82842ZM1.94292 6.81392L3.19767 4.66317L4.45184 6.81392H1.94292ZM11.4413 3.94625H12.3373V2.99075H8.09592V2.33334H6.24384V2.99075H1.94292V3.94625H2.83892L1.1665 6.9335C1.1665 8.06867 2.0625 8.96467 3.19767 8.96467C4.33225 8.96467 5.22825 8.06867 5.22825 6.9335L3.55584 3.94625H6.18434V11.2945H4.81059V12.25H9.52975V11.2945H8.09592V3.94625H10.7244L9.052 6.9335C9.052 8.06867 9.948 8.96467 11.0832 8.96467C12.2178 8.96467 13.1143 8.06867 13.1143 6.9335L11.4413 3.94625Z"
            fill="#232D37"
          />
        </svg>
      );
    default:
      return null;
  }
}
